<template>
    <svg
        aria-hidden="true"
        :class="[
            $style['mag-spinner-loading'],
            {
                [$style.inline]: inline,
                [$style.colored]: colored,
                [$style.mini]: mini,
            },
        ]"
        width="32"
        height="32"
        version="1.1"
        viewBox="0 0 67.733 67.733"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g :class="$style['mag-spinner-spin']">
            <g transform="matrix(.82287 0 0 .82287 5.9984 5.9989)">
                <path
                    d="m33.959 0.8413c-8.3737-0.008823-16.592 3.1643-22.849 9.1188-8.8995 8.4685-12.376 21.177-9.023 32.996l5.9686-1.681c-2.7249-9.6065 0.095231-19.927 7.329-26.811 7.2337-6.8834 17.845-8.9517 26.103-6.264l1.9737-5.9045c-2.9094-0.98361-4.8438-1.2553-7.8257-1.41-0.55911-0.028992-1.1178-0.044097-1.676-0.04468zm31.826 24.715-6.0201 1.553c2.4674 9.2417-0.15852 19.094-6.8993 25.88-6.7409 6.7861-16.177 9.1968-25.564 6.8428l-1.6444 5.9555c11.39 2.9597 23.3-0.07129 31.594-8.4205 8.2936-8.3492 11.569-20.441 8.5336-31.811z"
                    fill="currentColor"
                />
            </g>
            <g
                :class="$style['mag-butterflies']"
                transform="matrix(1.2958 .098299 -.098299 1.2958 .41715 -18.811)"
            >
                <path
                    d="m19.244 39.965c-0.62132 0.75445-1.2862 1.4845-1.8805 2.2541-0.45826 1.4275-0.95911 2.8484-1.3908 4.28 0.01197 0.7973 0.02382 1.5946 0.03574 2.3919-0.82611-0.0559-1.656-0.15529-2.4798-0.18435-1.4482 0.38557-2.9176 0.72632-4.3525 1.1398-0.76206 0.56257-1.5241 1.1251-2.2862 1.6877 0.00746 0.57752 0.014929 1.155 0.022392 1.7326 0.85814 0.49688 1.6647 1.0953 2.6101 1.4204 0.76646 0.32006 1.5329 0.64012 2.2994 0.96018 0.53911-0.39567 1.0782-0.79134 1.6173-1.187 0.01331 0.4126 0.02652 0.82522 0.03983 1.2378 0.55847 0.37816 1.0935 0.81873 1.6666 1.1579 0.94848 0.09538 1.897 0.19074 2.8454 0.28611 0.79636-0.46986 1.5927-0.93971 2.3891-1.4096-0.14459-0.67269-0.24382-1.3636-0.41647-2.025-0.40398-0.62711-0.79926-1.2606-1.2086-1.8838 0.62691 0.4569 1.2427 0.94576 1.8866 1.3706 0.63581 0.16906 1.2716 0.33814 1.9074 0.5072 0.52106-0.76381 1.0421-1.5276 1.5632-2.2914-0.05014-0.9802-0.03649-1.9797-0.12641-2.9479-0.33964-0.54964-0.67928-1.0993-1.0189-1.6489-0.41083-0.04035-0.82165-0.08069-1.2325-0.12099 0.43013-0.51202 0.86026-1.024 1.2904-1.5361-0.39788-1.1174-0.74239-2.2576-1.1736-3.3607-0.29327-0.56483-0.58654-1.1297-0.8798-1.6945-0.5758-0.0454-1.1516-0.09072-1.7274-0.13608z"
                    fill="currentColor"
                />
            </g>
            <g
                :class="$style['mag-butterflies']"
                transform="matrix(-1.2957 -.098293 .098293 -1.2957 66.781 86.854)"
            >
                <path
                    d="m19.244 39.965c-0.62132 0.75445-1.2862 1.4845-1.8805 2.2541-0.45826 1.4275-0.95911 2.8484-1.3908 4.28 0.01197 0.7973 0.02382 1.5946 0.03574 2.3919-0.82611-0.0559-1.656-0.15529-2.4798-0.18435-1.4482 0.38557-2.9176 0.72632-4.3525 1.1398-0.76206 0.56257-1.5241 1.1251-2.2862 1.6877 0.00746 0.57752 0.014929 1.155 0.022392 1.7326 0.85814 0.49688 1.6647 1.0953 2.6101 1.4204 0.76646 0.32006 1.5329 0.64012 2.2994 0.96018 0.53911-0.39567 1.0782-0.79134 1.6173-1.187 0.01331 0.4126 0.02652 0.82522 0.03983 1.2378 0.55847 0.37816 1.0935 0.81873 1.6666 1.1579 0.94848 0.09538 1.897 0.19074 2.8454 0.28611 0.79636-0.46986 1.5927-0.93971 2.3891-1.4096-0.14459-0.67269-0.24382-1.3636-0.41647-2.025-0.40398-0.62711-0.79926-1.2606-1.2086-1.8838 0.62691 0.4569 1.2427 0.94576 1.8866 1.3706 0.63581 0.16906 1.2716 0.33814 1.9074 0.5072 0.52106-0.76381 1.0421-1.5276 1.5632-2.2914-0.05014-0.9802-0.03649-1.9797-0.12641-2.9479-0.33964-0.54964-0.67928-1.0993-1.0189-1.6489-0.41083-0.04035-0.82165-0.08069-1.2325-0.12099 0.43013-0.51202 0.86026-1.024 1.2904-1.5361-0.39788-1.1174-0.74239-2.2576-1.1736-3.3607-0.29327-0.56483-0.58654-1.1297-0.8798-1.6945-0.5758-0.0454-1.1516-0.09072-1.7274-0.13608z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
</template>

<script lang="ts" setup>
withDefaults(
    defineProps<{
        inline?: boolean;
        colored?: boolean;
        mini?: boolean;
        em?: boolean;
    }>(),
    {
        inline: false,
        colored: true,
        mini: false,
        em: false,
    }
);
</script>

<style lang="scss" module>
@keyframes mag-loading-spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes mag-loading-butterfly-appear {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.mag-butterflies {
    opacity: 0;
    animation: 1s mag-loading-butterfly-appear 0s 1 ease-out forwards;
}

.mag-spinner-spin {
    animation: 2.5s mag-loading-spin infinite linear;
    transform-origin: center;
}

.mag-spinner-loading {
    display: block;

    position: relative;
    margin-block: 32px;
    cursor: wait;
    width: var(--size);
    height: var(--size);

    --size: 40px;

    &.colored {
        color: var(--accent);
    }

    &.inline {
        display: inline;
        --size: 32px;
    }

    &.mini {
        margin: 16px;
        --size: 16px;
    }

    &:not(.inline) {
        margin-inline: auto;
    }

    &.em {
        display: inline-block;
        vertical-align: middle;
        --size: 1em;
    }
}
</style>
